import { render, staticRenderFns } from "./RsaDynamicBodyAreaPage.vue?vue&type=template&id=0e1e2be8&scoped=true"
import script from "./RsaDynamicBodyAreaPage.vue?vue&type=script&lang=js"
export * from "./RsaDynamicBodyAreaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1e2be8",
  null
  
)

export default component.exports